import { HttpClient } from "@angular/common/http";
import { Component, Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap";
import { Observable } from "rxjs";
import { FeedbackComponent } from "../components/feedback/feedback.component";
import { FeedbackConfig, FeedbackType } from "../models/feedback-config.model";

@Injectable({
  providedIn: "root",
})
export class FeedbackService {
  private bsModalRef: BsModalRef;
  private initialState: FeedbackConfig;

  private baseUrl: string = environment.baseUrlWs + environment.wsVerison;

  constructor(private modalService: BsModalService, private http: HttpClient) { }

  public open(config: FeedbackConfig): void {
    this.initialState = {
      ...config,
    };

    const modalConfig = {
      initialState: this.initialState,
      class: config.modal.modalClass || "",
    } as ModalOptions;

    // console.log('modalConfig', modalConfig);

    this.bsModalRef = this.modalService.show(FeedbackComponent, modalConfig);
  }

  createFeedback(
    type: FeedbackType,
    rating: number,
    comment?: string
  ): Observable<any> {
    const url = `${this.baseUrl}employer/feedbacks`;
    const userData: any = JSON.parse(localStorage.getItem("userData"));
    const body: any = {
      usersId: String(userData["Teams"][0].employers_id),
      type: type,
      feedbacksValues: [
        {
          key: "rating",
          value: rating,
        },
        {
          key: "comment",
          value: comment,
        },
        {
          key: "teamsId",
          value: String(userData["Teams"][0].id),
        }
      ],
    };

    if (this.initialState.extraFeedbackValues) {
      body.feedbacksValues.push(...this.initialState.extraFeedbackValues)
    }
    return this.http.post(url, body) as Observable<any>;
  }
}
